<div mat-dialog-title style="margin:0px;">{{ PageTitle }}</div>
<mat-dialog-content>

        <!-- This section will allow the user to create new Modules / Portals (Areas / Subareas) -->
        <div style="padding: 10px" *ngIf="PageTitle === 'Add Portal'">
            {{ Message }}
            <td>
                Module <br />
                <mat-select id="elementsAndAreasDdlAreas" name="elementsAndAreasDdlAreas"
                [ngModel]="distinctTestAreas"
                aria-label="Module Drop Down List">
                    <mat-option *ngFor="let item of distinctTestAreas; index as i;"
                    id="area{{i}}"
                    [value]="item"
                    [attr.aria-label] = "item.AreaName"
                    (click) = "setAreaName(item.AreaName);"
                    >
                        {{ item.AreaName }}
                    </mat-option>
                </mat-select>
            </td>
            <td>
                Portal <br />
                <input #NewPortalName type='text' spellcheck="true"
                id="txtElementsAndAreasNewPortalName"
                name="txtElementsAndAreasNewModuleName"
                aria-label="Portal Name or Tab / View Name Input"
                rows="1">
            </td>
        </div>

           <!-- This section will allow the user to create new Modules / Portals (Areas / Subareas) -->
           <div style="padding: 10px" *ngIf="PageTitle === 'Add Page and/or Tab / View'">
            {{ Message }}
            <td>
                Page Name<br />
                <input #NewAreaName type='text' spellcheck="true"
                id="txtElementsAndAreasNewModuleName"
                [ngModel]="this.areaName"
                name="txtElementsAndAreasNewModuleName"
                aria-label="Module or Page Name Input"
                rows="1">
            </td>
            <td>
                Tab / View<br />
                <input #NewPortalName type='text' spellcheck="true"
                id="txtElementsAndAreasNewPortalName"
                [ngModel]="subAreaName"
                name="txtElementsAndAreasNewModuleName"
                aria-label="Portal Name or Tab / View Name Input"
                rows="1">
            </td>
        </div>

        <!-- This section allows the user to update existing portals; any changes here will be applied to the previously selected area. -->
        <div style="padding: 10px" *ngIf="PageTitle === 'Edit Portal'">
            {{ Message }}
            <td>
                Module <br />
                <mat-select id="elementsAndAreasDdlAreas" name="elementsAndAreasDdlAreas"
                [ngModel]="areaName"
                placeholder="{{ areaName }}"
                aria-label="Module Drop Down List">
                    <mat-option *ngFor="let item of distinctTestAreas; index as i;"
                    id="area{{i}}"
                    [value]="item"
                    [attr.aria-label] = "item.AreaName"
                    (click) = "setAreaName(item.AreaName)"
                    >
                        {{ item.AreaName }}
                    </mat-option>
                </mat-select>
            </td>
            <td>
                Portal<br />
                <input #NewPortalName type='text' spellcheck="true"
                id="txtElementsAndAreasNewPortalName"
                [ngModel]="subAreaName"
                name="txtElementsAndAreasNewModuleName"
                placeholder="{{ subAreaName }}"
                aria-label="Portal Name or Tab / View Name Input"
                rows="1">
            </td>
        </div>


    <!-- This section allows the user to update existing areas; any changes here will be applied to the previously selected area. -->
    <div style="padding: 10px" *ngIf="PageTitle === 'Edit Page and / or Tab / View'">
        {{ Message }}
        <td>
            Page Name<br />
            <input #NewAreaName type='text' spellcheck="true"
            id="txtElementsAndAreasNewModuleName"
            [ngModel]="areaName"
            name="txtElementsAndAreasNewModuleName"
            placeholder="{{ areaName }}"
            aria-label="Module or Page Name Input"
            rows="1">
        </td>
        <td>
            Tab / View<br />
            <input #NewPortalName type='text' spellcheck="true"
            id="txtElementsAndAreasNewPortalName"
            [ngModel]="subAreaName"
            name="txtElementsAndAreasNewModuleName"
            placeholder="{{ subAreaName }}"
            aria-label="Portal Name or Tab / View Name Input"
            rows="1">
        </td>
    </div>
</mat-dialog-content>

    <!-- Footer -->
    <mat-dialog-actions>
        <div class="flex-footer-right">
            <tyl-button id="okButton" image="check.png" label="Save" aria-label= "Save Button" (click)="okClick()"></tyl-button>
            <tyl-button id="cancelButton" image="cancel.png" label="Cancel" aria-label="Cancel Button" (click)="cancelClick()"></tyl-button>
        </div>
    </mat-dialog-actions>
